module.exports = __webpack_public_path__ + "img/eureka-tower-climb.ec575ba9.jpg";